import type { RouteObject } from "react-router-dom";

/*
  F03 web_overview: the Overview view of the 2026-11-03 design (rebuild package 4.5F). The view loads when it is first opened.
  Who may open the address is in `app/screens.ts`; it is not repeated here.
*/

export const routes: RouteObject[] = [{ path: "/overview", lazy: async () => ({ Component: (await import("./OverviewView")).OverviewView }) }];
